module.exports = __webpack_public_path__ + "assets/img/soccer.webp?ffa907091e4020a0c6198e7fa7e70b4b";